<template>
  <div class="HomeNav">
    <div class="container_w clear">
        <ul class="clear">
            <a href="javascript:;" v-for="(item,index) in navTitleList" :key="index" @click="navCheck(index)">
                <li :class="{'nav_list_active':navState==index}"><span><i></i>{{item.name}}</span></li>
            </a>
        </ul>
        <nav-book v-if="navState == 0"></nav-book>
<!--        <nav-online v-else-if="navState == 1"></nav-online>-->
        <nav-flight v-else-if="navState == 1"></nav-flight>
        <nav-order v-else></nav-order>
        <!-- <nav-book v-show="navState == 0"></nav-book>
        <nav-online v-show="navState == 1"></nav-online>
        <nav-flight v-show="navState == 2"></nav-flight>
        <nav-order v-show="navState == 3"></nav-order> -->
    </div>
  </div>
</template>

<script>
import NavBook from "./NavBook";
// import NavOnline from "./NavOnline";
import NavFlight from "./NavFlight";
import NavOrder from "./NavOrder";
export default {
  components: {
    NavBook,
    // NavOnline,
    NavFlight,
    NavOrder
  },
  name: 'HomeNav',
  data () {
    return {
        navState:0,
        navTitleList:[
            {name:'Book a Flight'},
            // {name:'Online Check-in'},
            // {name:'Flight Status'},
            // {name:'Order Management'},
        ]
    }
  },
  props: {

  },
  watch: {

  },
  methods: {
    navCheck(i){
        this.navState = i
    }
  },
  filters: {

  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  destroyed () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
    .HomeNav{
        position: relative;
        background:#fff;
        box-shadow: 0px 6px 8px 0px rgba(0,0,0,0.04);
        .container_w{
            position: relative;
            padding: 32px 0;
            ul{
                position: absolute;
                top: -32px;
                a{
                    &:first-child{
                        i{
                            background: url(../../../assets/home/icon_nav_home_book.png) no-repeat center;
                        }
                    }
                    &:last-child{
                        i{
                            background: url(../../../assets/home/icon_nav_home_management.png) no-repeat center;
                        }
                    }
                    &:nth-child(2){
                        i{
                            background: url(../../../assets/home/icon_nav_home_checkin.png) no-repeat center;
                        }
                    }
                    &:nth-child(3){
                        i{
                            background: url(../../../assets/home/icon_nav_home_status.png) no-repeat center;
                        }
                    }
                }
                li{
                    float: left;
                    width: 280px;
                    height: 64px;
                    text-align: center;
                    background:rgba(72,77,83,1);
                    box-shadow:-2px 0px 0px 0px rgba(255,255,255,0.1);
                    font-size:18px;
                    color:rgba(255,255,255,1);
                    cursor: pointer;
                    &:hover{
                        background:rgba(216,0,15,1);
                        box-shadow:-2px 0px 0px 0px rgba(255,255,255,0.1);
                    }

                    span{
                        position: relative;
                        display: inline-block;
                        line-height: 64px;
                        padding-left: 40px;
                        i{
                            position: absolute;
                            width: 32px;
                            height: 32px;
                            background-size: 100% 100%;
                            top: 50%;
                            left: 0;
                            margin-top: -16px;
                        }
                    }


                }
                .nav_list_active{
                    background:rgba(216,0,15,1);
                    box-shadow:-2px 0px 0px 0px rgba(255,255,255,0.1);
                }
            }
        }
    }

</style>
